function initSpecialsSlider() {
  const slider = document.querySelector('[data-slider="special"]');

  if (!slider) {
    return;
  }

  const swiper = new Swiper(slider, {
    slidesPerView: 1,
    navigation: {
      nextEl: ".special__next-btn",
      prevEl: ".special__prev-btn",
    },
  });
}

export { initSpecialsSlider };
